module.exports = __webpack_public_path__ + "img/happy_face.5fb1242d.svg";